module.exports = __webpack_public_path__ + "img/tp2.e01dea2a.jpg";